/* eslint-disable */
export default {
  _salutationinfo: 'salutationinfo',
  _headinginfo: 'headinginfo',
  _signatureinfo: 'signatureinfo',
  _letter: 'letter',
  _footer: 'footer',
  _envelope: 'envelope',
  _closinginfo: 'closinginfo',
  _bodyinfo: 'bodyinfo',
  _pencil: 'pencil',
}